import GiftCardsPreview from './GiftCardsPreview';

export default GiftCardsPreview;
